// ======================================================================
// FILE:
// src/modules/finance/components/FinanceSearchPanel.jsx
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// COMPONENT:
// Finance Search Panel
//
// PURPOSE:
// Standard search/filter panel for Finance screens.
//
// FEATURES:
// - Responsive
// - Bootstrap only
// - Dynamic filter area
// - Search button
// - Reset button
// - Optional extra actions
//
// AUTHOR:
// DizyPro ERP
// ======================================================================

import React from "react";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceSearchPanel({

    children,

    onSearch,

    onReset,

    loading = false,

    extraActions = null,

}) {

    return (

        <div className="card shadow-sm border-0 mb-4">

            <div className="card-body">

                {/* ======================================================
                    HEADER
                ====================================================== */}

                <div
                    className="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-3
                        flex-wrap
                        gap-2
                    "
                >

                    <h5 className="mb-0 fw-semibold">

                        Search & Filters

                    </h5>

                    {extraActions}

                </div>

                {/* ======================================================
                    FILTERS
                ====================================================== */}

                <div className="row g-3">

                    {children}

                </div>

                {/* ======================================================
                    BUTTONS
                ====================================================== */}

                <div
                    className="
                        d-flex
                        justify-content-end
                        flex-wrap
                        gap-2
                        mt-4
                    "
                >

                    <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={onReset}
                    >

                        <i className="fas fa-undo me-2" />

                        Reset

                    </button>

                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={onSearch}
                        disabled={loading}
                    >

                        {
                            loading
                                ? (
                                    <>
                                        <span
                                            className="
                                                spinner-border
                                                spinner-border-sm
                                                me-2
                                            "
                                        />

                                        Searching...

                                    </>
                                )
                                : (
                                    <>
                                        <i className="fas fa-search me-2" />

                                        Search
                                    </>
                                )
                        }

                    </button>

                </div>

            </div>

        </div>

    );

}